import parseDialogue from "../../util/parseDialogue";

export const SpinnerP7 = parseDialogue(`
spinner:p3:100-300

#100 Great work, agent. P.E.D. thanks you. So, mind letting little old Spinner know what all the big bad news is about?
>200 Later. I've got to work.

#200 No problem, no problem. Duty first and all. Just don't forget who's been your friend, okay? Here are your credits. Ciao, buddy.
>300 Ready to receive credit transfer.
`);
